/* tslint:disable */
/* eslint-disable */
/**
 * Courtiers API
 * API des listes de courtiers (facettes, tri, scope compagnie/admin)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Un courtier de la liste (rattaché à un compte utilisateur). Champs email/phone/siret/ orias/category absents si null.
 * 
 * @export
 * @interface CourtierListItem
 */
export interface CourtierListItem {
    /**
     * 
     * @type {string}
     * @memberof CourtierListItem
     */
    id: string;
    /**
     * PM du cabinet (utilisée par les écrans d'accès et de portefeuille)
     * @type {string}
     * @memberof CourtierListItem
     */
    personneMoraleId?: string;
    /**
     * Nature de la PM (CRT, CIE, MIA, PIM…) — filtrages d'éligibilité
     * @type {string}
     * @memberof CourtierListItem
     */
    natureCode?: string | null;
    /**
     * Sous-nature de la PM (ex. GRO pour grossiste)
     * @type {string}
     * @memberof CourtierListItem
     */
    sousNatureCode?: string | null;
    /**
     * Raison sociale
     * @type {string}
     * @memberof CourtierListItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CourtierListItem
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourtierListItem
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourtierListItem
     */
    siret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourtierListItem
     */
    orias?: string | null;
    /**
     * Libellé de la catégorie d'intermédiaire
     * @type {string}
     * @memberof CourtierListItem
     */
    category?: string | null;
    /**
     * Prénom + nom du compte utilisateur
     * @type {string}
     * @memberof CourtierListItem
     */
    contactName: string;
    /**
     * Dernière connexion (ISO). ABSENT si le courtier ne s'est jamais connecté.
     * @type {Date}
     * @memberof CourtierListItem
     */
    lastLoginAt?: Date | null;
    /**
     * Date de création
     * @type {Date}
     * @memberof CourtierListItem
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof CourtierListItem
     */
    simulationCount: number;
    /**
     * 
     * @type {number}
     * @memberof CourtierListItem
     */
    quoteCount: number;
    /**
     * 
     * @type {number}
     * @memberof CourtierListItem
     */
    contractCount: number;
    /**
     * 
     * @type {number}
     * @memberof CourtierListItem
     */
    clientCount: number;
    /**
     * Somme des primes quittancées des contrats en cours (EUR). Toujours présent (0 si aucun contrat). Scopé à la plateforme en vue orga / aux plateformes filtrées en admin. Triable via sortBy=totalPremium.
     * 
     * @type {number}
     * @memberof CourtierListItem
     */
    totalPremium: number;
}

/**
 * Check if a given object implements the CourtierListItem interface.
 */
export function instanceOfCourtierListItem(value: object): value is CourtierListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('contactName' in value) || value['contactName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('simulationCount' in value) || value['simulationCount'] === undefined) return false;
    if (!('quoteCount' in value) || value['quoteCount'] === undefined) return false;
    if (!('contractCount' in value) || value['contractCount'] === undefined) return false;
    if (!('clientCount' in value) || value['clientCount'] === undefined) return false;
    if (!('totalPremium' in value) || value['totalPremium'] === undefined) return false;
    return true;
}

export function CourtierListItemFromJSON(json: any): CourtierListItem {
    return CourtierListItemFromJSONTyped(json, false);
}

export function CourtierListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtierListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'personneMoraleId': json['personneMoraleId'] == null ? undefined : json['personneMoraleId'],
        'natureCode': json['natureCode'] == null ? undefined : json['natureCode'],
        'sousNatureCode': json['sousNatureCode'] == null ? undefined : json['sousNatureCode'],
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'siret': json['siret'] == null ? undefined : json['siret'],
        'orias': json['orias'] == null ? undefined : json['orias'],
        'category': json['category'] == null ? undefined : json['category'],
        'contactName': json['contactName'],
        'lastLoginAt': json['lastLoginAt'] == null ? undefined : (new Date(json['lastLoginAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'simulationCount': json['simulationCount'],
        'quoteCount': json['quoteCount'],
        'contractCount': json['contractCount'],
        'clientCount': json['clientCount'],
        'totalPremium': json['totalPremium'],
    };
}

export function CourtierListItemToJSON(json: any): CourtierListItem {
    return CourtierListItemToJSONTyped(json, false);
}

export function CourtierListItemToJSONTyped(value?: CourtierListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personneMoraleId': value['personneMoraleId'],
        'natureCode': value['natureCode'],
        'sousNatureCode': value['sousNatureCode'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'siret': value['siret'],
        'orias': value['orias'],
        'category': value['category'],
        'contactName': value['contactName'],
        'lastLoginAt': value['lastLoginAt'] == null ? undefined : ((value['lastLoginAt'] as any).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'simulationCount': value['simulationCount'],
        'quoteCount': value['quoteCount'],
        'contractCount': value['contractCount'],
        'clientCount': value['clientCount'],
        'totalPremium': value['totalPremium'],
    };
}

